import Button             from '@widesk-ui/components/Button';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';
import { BellOutlined }   from '@ant-design/icons';

const NotificationButton = () => {
	if (!currentEditorStore.isCenterDefined) return null;

	return <Button className="nc-trigger nc-trigger-corner" icon={<BellOutlined />} type="primary" />;
};

export default NotificationButton;